<div class="co-sign-container">
    <div>
        <app-page-header title="Co-Sign"></app-page-header>
    </div>
    <div class="p-4">
        <div class="tabs-container">
            <tabs
                [tabs]="tabs"
                [tabIndex]="tabIndex"
                (tabChange)="tabChange($event)"
            ></tabs>

            <thera-dropdown *ngIf="canCoSignForTeam" class="custom-dropdown h-[45px] pr-3 w-80" 
            [options]="therapists"
            [defaultSelection]="userId"
            [placeholder]="'Select User'"
            (optionSelected)="onTherapistSelected($event)"
            ></thera-dropdown>
        </div>

        <ng-container *ngComponentOutlet="selectedComponent; injector: customInjector"></ng-container>
    </div>
</div>
